import React from 'react';
import { Layout } from 'antd';
import WorkBasket from '../components/WorkBasket';

const { Content } = Layout;

const WorkBasketPage = () => {
  return (
    <Layout style={{ minHeight: '100vh', backgroundColor: '#f0f2f5' }}>
      <Content>
        <WorkBasket />
      </Content>
    </Layout>
  );
};

export default WorkBasketPage;
